import { PageHeader } from '@/components/layout/PageHeader';
import { CollectionTable } from '../components/CollectionTable';
import { Button } from '@/components/ui/button';
import { Link } from '@tanstack/react-router';
import { Plus, Download } from 'lucide-react';
import { CollectionsService } from '@/services/collections-service';
import { Collection } from '../types';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';

export function CollectionsPage() {
  const [collections, setCollections] = useState<Collection[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      setLoading(true);
      const result = await CollectionsService.getCollections();
      setCollections(result.collections);
    } catch (error) {
      console.error('Error fetching collections:', error);
      toast.error('Failed to load collections');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchCollections();
  };

  return (
    <>
      <PageHeader
        title="Collections"
        description="Manage document collections and groupings."
        actions={
          <>
            <Button variant="outline" size="sm">
              <Download className="mr-2 h-4 w-4" />
              Export
            </Button>
            <Button asChild size="sm">
              <Link to="/collections/add">
                <Plus className="mr-2 h-4 w-4" />
                Add Collection
              </Link>
            </Button>
          </>
        }
      />
      
      <div className="space-y-4">
        <CollectionTable 
          data={collections} 
          loading={loading}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}

export default CollectionsPage;
